import * as Models from "../.";
export class PrePtoAccountData {
  activeEpcCalculations: Models.CostCalculation.EpcCalculation.IEpcCalculationResult[];
  pendingEpcCalculation: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
  customerEvents: Models.Customer.CustomerEventMap.CustomerEventMap;
  utilityName: string;
  regionName: string;
  assignedUsers: Models.UserModel.IUserModel[];
}
